module.exports = __webpack_public_path__ + "img/interferenciaGps.4f56305b.svg";